import Phaser from 'phaser';
import { CHEST } from '../config/GameConfig';

/**
 * Chest —— 金边木箱（用 'chest-gold' 贴图）
 *
 * 玩家撞到时计数 +1，达到阈值（默认 3）触发升级面板。
 */
export default class Chest extends Phaser.GameObjects.Container {
  declare body: Phaser.Physics.Arcade.Body;
  private _sprite: Phaser.GameObjects.Image;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);
    scene.physics.add.existing(this);

    const w = CHEST.width;
    const h = CHEST.height;

    const shadow = scene.add.ellipse(0, h / 2 - 4, w * 0.85, 8, 0x000000, 0.3);
    this._sprite = scene.add.image(0, 0, 'chest-gold');
    // 贴图源比物理框大，等宽缩放（保留漂浮 tween 用的相对 y）
    const baseScale = w / this._sprite.width;
    this._sprite.setScale(baseScale);
    this.add([shadow, this._sprite]);

    this.body.setSize(w, h);
    this.body.setOffset(-w / 2, -h / 2);
    this.body.setAllowGravity(false);

    // 漂浮幅度根据缩放后的实际尺寸来，不能直接 from -2 to 2 否则在小贴图上看不到
    scene.tweens.add({
      targets: this._sprite,
      y: { from: -2, to: 2 },
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    scene.tweens.add({
      targets: this._sprite,
      alpha: { from: 1, to: 0.85 },
      duration: 900,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}
